export default function getDistributor() {
  return useDistributorConfig().value || useWorkspaceStore().distributor || null;
}
